import { FC, useState } from 'react';
import { useVaults } from '@hooks/use-vaults';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { type CoinStruct } from '@models/coins.vault.model';
import VaultItem from './vault-item';
import { type MyVaultsStruct } from '@models/myvault.model';
import { type ProtocolListType } from '@constants/protocol-list';

interface OwnProps {
  searchValue: CoinStruct[];
  myVaults?: MyVaultsStruct[];
}

const VaultAll: FC<OwnProps> = ({ searchValue, myVaults }) => {
  const [sortType, setSortType] =
    useState<OpenapiClientParrotVault.GetVaultVaultsQuery['direction']>('desc');
  const [sortValue, setSortValue] =
    useState<OpenapiClientParrotVault.GetVaultVaultsQuery['sort']>('liquidity_usd');
  const [protocolValue, setProtocolValue] = useState<ProtocolListType>('all');

  const { vaults } = useVaults({
    direction: sortType,
    sort: sortValue,
    tokens: searchValue.map((item) => item.coin_type),
    protocol: protocolValue === 'all' ? undefined : protocolValue,
  });

  const handleSort = (value: OpenapiClientParrotVault.GetVaultVaultsQuery['sort']) => {
    if (sortValue === value) {
      setSortType(sortType === 'desc' ? 'asc' : 'desc');
    } else {
      setSortType('desc');
    }
    setSortValue(value);
  };

  return (
    <VaultItem
      vaults={vaults}
      handleSort={handleSort}
      sortType={sortType}
      sortValue={sortValue}
      protocolValue={protocolValue}
      onChangeProtocolValue={setProtocolValue}
      myVaults={myVaults}
    />
  );
};

export default VaultAll;
